import * as core from '../../../../../../../core'

import { query } from './cursor-event-table.query'

export const RESOURCE = {
  payload: {
    alias: 'cursor.event.table',
    description:
      'Table of all recorded Cursor usage events. Not yet implemented.',
    name: 'Cursor Event Table',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
